// Typed accessors for non-standard window/navigator globals (§18 adapter boundary)
function getManualLang() {
  const raw = window.I18N_MANUAL_LANG;
  return typeof raw === 'string' ? raw : '';
}
function getLegacyNavLang(key) {
  const raw = window.navigator[key];
  return typeof raw === 'string' ? raw : '';
}

/**
 * Returns the browser's preferred language string (e.g. 'en-US', 'de').
 *
 * This is intentionally kept import-free so it can be called from
 * publicEarlyRequester.ts before any module bundling side-effects run.
 *
 * Copied from pricing-pages-lib/utils/getPreferredLanguage — do not import from there.
 */
export const getPreferredLanguage = () => {
  const manualLang = getManualLang();
  if (manualLang) {
    return manualLang;
  }
  const nav = window.navigator;
  if (nav.languages && nav.languages.length) {
    return nav.languages[0];
  }
  return nav.language || getLegacyNavLang('userLanguage') || getLegacyNavLang('browserLanguage') || getLegacyNavLang('systemLanguage') || '';
};